events = {
    // Funkcia na vyrenderovanie events v ramci kurzovej ponuky
    eventsRender(data) {
        try {
            if (offer.page == "results" && data.Results) data.EventChanceTypes = data.Results;
            if (stream.isStreamPlaying && !stream.isActualOfferDifferentAsStream()) {
                var isStreamEnded = stream.isConditionForStreamEnd(data);
                if (isStreamEnded) {
                    stream.streamEnd();
                }
            }

            if (data && !data.ErrorType && data.EventChanceTypes && data.EventChanceTypes.length) {
                // Standartne stavky (filtrom nastavi offer.eventsVictoria)
                offer.eventsVictoria = false;
                // Render udalosti mimo oblubenych
                stored.isFavoriteRender = false;
                var betTypes = [];
                // Defaultne sa nastavi priznak streamu na ukonceny
                // Zmena z prebiehajuceho na ukonceny zapas - stream sa nezistuje cez signalR pretoze gamepart 'ended' prichadza aj pri ukonceni ciastkovych gamepartov (stvrtiny, polcasy, ...)
                data.EventChanceTypes.forEach(function (eChanceType, ect) {
                    if ((eChanceType.EventChanceTypeID === 0 || typeof eChanceType.BetType === "undefined") && eChanceType.EventType !== "special") {
                        // Jedna sa o udalost bez Master Chance Type preto vytvori suspendovane oddy s kurzom 1 ktore sa vykreslia do plachty
                        data.EventChanceTypes[ect].BetType = "NO-MASTER";
                        offer.sextaTips.forEach(function(sextaTip, st) {
                            data.Odds[eChanceType.EventChanceTypeID + "_" + sextaTip] = {
                                TipID: 0,
                                EventChanceTypeID: eChanceType.EventChanceTypeID,
                                Status: "suspended",
                                TipOrder: (st + 1) + "0",
                                TipType: sextaTip,
                                OddsRate: 1
                            };
                        });
                    }
                    // Prida betType do zoznamu
                    if (!betTypes.includes(eChanceType.BetType)) betTypes.push(eChanceType.BetType);
                });
                $("#events #section").removeClass("virtuals-octava events-no-master-view events-sexta-view events-duo-view").hide();
                $('#sportBox .content-table').parent().removeClass('is-victoria is-no-master is-duo is-sexta exclude-12');

                if (offer.page === "sportsBook") {
                    $("#tableTop .table-overall-title").text(texts.HeaderLabelOffer);
                } else if (offer.page === "virtualGames") {
                    $('.content-offer').removeClass('ui-disabled');
                }
                if (stored.ExtendedActualOffer) {
                    $('#sportBox .content-table').parent().removeClass('is-fat-menu').addClass('is-narrow-menu');

                    if (!betTypes.includes("DUO") && !betTypes.includes("TRIO")) {
                        // Zobrazeni budu len viktorky
                        stored.offerView = "victoria";
                    } else if (betTypes.includes("TRIO")) {
                        // && offer.provider !== "KRN"
                        if (offer.kvintaSports.includes(offer.sportID) || (offer.regionID === 1239 && offer.provider === offer.providerNameUOF)) {
                            stored.offerView = "sexta exclude-12";
                        } else {
                            stored.offerView = "sexta";
                        }
                    } else if (betTypes.includes("DUO")) {
                        stored.offerView = "duo";
                    } else if (betTypes.includes("NO-MASTER")) {
                        stored.offerView = "no-master";
                    }

                    // Render ponuky
                    $('#sportBox .content-table').parent().addClass('is-' + stored.offerView);
                    $("#events #section").addClass(stored.offerView);
                    $p("#events #section").render(data, T.eventsSexta);
                } else {
                    // Render ponuky
                    $('#sportBox .content-table').parent().removeClass('is-narrow-menu').addClass('is-fat-menu');
                    $p("#events #section").render(data, T.events);
                }
                // Specialne stavky Victoria (titulok sa zobrazi len ak nie je uplne prva)
                if (offer.eventsVictoria) {
                    var victoria = "events-victoria-title";
                    // Ak niesu klasicke zapasy, alebo sa jedna o render oblubenych tak skryje popisok Speciálne stávky
                    if (!$("#section .events-list li").length || offer.favSportID) victoria += " victoria-title-hidden";
                    // Render ponuky
                    $("#events #section").append("<div class='" + victoria + "'>" + texts.EventsVictoria + "</div><div id='eventsVictoria'></div>").addClass("scroll-offer");
                    $p("#events #section #eventsVictoria").render(data, T.eventsVictoria);
                    if (offer.sportID != offer.vgID ) {
                        $("#events #section .events-victoria .ui-block-4").hide();
                    }
                    if (offer.pointer === "FA0") {
                        // Ak sa jedna o oblubene tak presunie viktorky pod dany sport
                        Object.keys(stored.PlayerFavorite.pFavorites).forEach(function(sportID) {
                            if (victoria = $("#section .events-victoria .league-title[sport-id='SP" + sportID + "']").parent().addClass("events-victoria")) {
                                if (victoria.length) {
                                    if (mEvent = $("#section .events-list").first().find(".league-title[sport-id='SP" + sportID + "']").last()) {
                                        if (mEvent.length) {
                                            victoria.find(".events-n-sport-header").remove();
                                            mEvent.parent().after(victoria);
                                        }
                                    }
                                }
                            }
                        });
                    }
                }
                // Oblubene udalosti v plachte
                if (stored.playerFavoriteEventData && stored.playerFavoriteEventData.length) {
                    $("#events #section").prepend("<div id='favorite'></div>");
                    lastSportID = 0;
                    sportName =  "";
                    stored.isFavoriteRender = true;
                    $p("#events #section #favorite").render(data, T.eventsSexta);
                }
                $("#events #noEvents").hide();
                $("#events #section").show();
                if (profile.pageActualisationInfo.includes(offer.page)) {
                    $("#pageActualisationInfo").show();
                }

                // Tlacitko AllEvent
                var eventsLength = (offer.vgID === offer.sportID && data.mergedEvents)? Object.keys(data.mergedEvents).length: data.EventChanceTypes.length;
                if (eventsLength >= offer.topOffer && (!offer.pointer || (offer.pointer && offer.pointer.substr(0, 1) !== "F"))) {
                    var allEvents = $("#sportsBook #" + offer.pointer + " .ui-li-count").html() || stored.allMenuSum || 0;
                    if (allEvents) {
                        allEvents = texts.OfferAll + ": " + allEvents;
                    } else {
                        allEvents = texts.OfferAll;
                    }
                    $("#showAllEvents").show().find(".ui-btn-text").html(allEvents);
                } else {
                    $("#showAllEvents").hide();
                }
                // Zaskroluje na poziciu kde bol pred stlacenim tlacitka showAllEvents
                if (stored.allEvents) setTimeout(function () {
                    shared.scrollModule.checkScroll(".content-table", "#events", stored.allEvents, "fast");
                    stored.allEvents = null;
                }, 1000);

                if (profile.QuickBetsAllowed && offer.page === "onlyLive" && ((profile.QuickBets.Live && [-1].includes(offer.sportID)) || profile.QuickBets.Sport && [profile.QuickBets.SportID].includes(offer.sportID))) {
                    // Zobrazi QuickBet button v ponuke
                    quickbet.showQuickBetButton("live");
                } else {
                    // Skryje QuickBet button v ponuke
                    quickbet.showQuickBetButton("live", true);
                }
            } else {
                $("#events #noEvents").show();
                $("#events #section").empty();
                // Nanovo nacita ponuku
                switch (offer.page) {
                    case "popularLeagues":
                        service.loadPure('popularLeagues');
                        break;
                    case "virtualGames":
                        service.loadPure('virtualGames');
                        break;
                    default:
                        service.loadPure('sportsBook');
                        break;
                }
                modal.showErrObj(2, 5, {err1: texts.OfferNoEvents, errType: "OfferNoEvents"});
            }

            if (profile.FlatCSS) shared.scrollModule.scrollButtons("table");
            $("#sportsBook, #sportsBookLG, #events").removeAttr("class");
            $("#sportsBookVG").removeClass("ui-disabled");
            return true;

        } catch (e) {
            console.error("ERROR catched in function: " + main.catchFunctionCall(arguments));
            main.setPage(1);
            modal.showErrObj(1, 5, {err1: texts.ConnectionErr, errType: "ConnectionErr"});
            return false;
        }
    },

    // Nacitanie kompletneho event listu
    showAllEvents() {
        try {
            if (offer.page == "virtualGames") {
                stored.allEvents = $(".content-table").scrollTop();
                service.loadPure('sportsBookEvents', null, false, true);
                return true;
            } else if (offer.pointer) {
                var allEventsCount = parseInt($("#sportsBook #" + offer.pointer + " .ui-li-count").html()) || stored.allMenuSum || 0;
                // ošetrenie ponuky keď je v nej spolu viac ako 500 udalostí
                if ((allEventsCount < offer.maxOffer)) {
                    stored.allEvents = $(".content-table").scrollTop();
                    service.loadPure('sportsBookEvents', null, false, true);
                    return true;
                } else {
                    modal.showErrObj(2, 5, {err1: texts.OfferAllMax, err2: texts.OfferMsg, errType: "OfferAllMax"});
                    return false;
                }
            } else {
                return false;
            }
        } catch (e) {
            console.error("ERROR catched in function: " + main.catchFunctionCall(arguments));
            return false;
        }
    },

    // Funkcia vytvara bet type header pre duo a trio
    betTypeHeader(here) {
        try {
            var betTypes = "";
            if (here.BetType == "DUO" && stored.offerView.includes('duo')) {
                betTypes += '<div class="bet-type-header-2"><div>1</div><div>2</div></div>';
            } else if (here.BetType == "DUO" || here.BetType == "TRIO") {
                if (stored.offerView.includes('exclude-12')) {
                    // Zobraz hlavicku pre kvintu
                    betTypes += '<div class="bet-type-header-2"><div>1</div><div>X</div><div>2</div><div>1X</div><div>X2</div></div>';
                } else {
                    // Zobraz hlavicku pre sextu
                    betTypes += '<div class="bet-type-header-2"><div>1</div><div>X</div><div>2</div><div>1X</div><div>X2</div><div>12</div></div>';
                }
            }
            return betTypes;
        } catch (e) {
            console.error("ERROR catched in function: " + main.catchFunctionCall(arguments));
            return '';
        }
    },

    // Funkcia vytvara cervene a zlte karty v kurzovej ponuke
    resolveCards(parsedScore, sportsID, team) {
        try {
            if (sportsID === 54 && parsedScore[team]) {
                var result = '';
                if (parsedScore[team].cardsRed > 0) {
                    result = '<span class="penalty-card red-card">' + parsedScore[team].cardsRed + '</span>';
                }
                if (parsedScore[team].cardsYellow > 0) {
                    result += '<span class="penalty-card yellow-card">' + parsedScore[team].cardsYellow + '</span>';
                }
                return result;
            }
            return '';
        } catch (e) {
            console.error("ERROR catched in function: " + main.catchFunctionCall(arguments));
            return '';
        }
    },

    // Funkcia na render sportovej hlavicky v plachte
    sportHeader(sportID, sportName, buttonState) {
        try {
            var favoriteButton = "";
            if (buttonState) {
                // Prida tlacitko oblubene
                favoriteButton = '<div class="favorite-event '
                + buttonState + '" onmousedown="player.playerFavoritesModule.editPlayerFavorite('
                + sportID + ')"><div class="icon-favorite"></div></div>';
            }
            return '<div class="header-wrapper">'
                + favoriteButton +'<i class="header-icon ui-icon-sports sport-'
                + sportID + ' sport-color-'
                + sportID + ' sport-icon-'
                + sportID + '"></i><h2 class="header-sport">'
                + sportName + '</h2><div class="header-background sport-bgColor-gradient-'
                + sportID + '">' + '</div></div>';
        } catch (e) {
            return false;
        }
    },

    // Spristupni event / chanceType
    unlockEvent(oddID, eventID) {
        try {
            if (oddID && eventID) {
                // Spristupni tlacitka daneho evenu v chanceType
                $("#events #M" + eventID).children("fieldset").removeClass("lock-btn");
                $("#eventsOfDay #" + oddID).parents('.event-of-day').removeClass("lock-btn");
                if (offer.eventID) $("#event .chances").removeClass("lock-btn");
            } else {
                // Spristupni tlacitka vsetkych eventov a chanceType
                $("#events fieldset").removeClass("lock-btn");
                $("#eventsOfDay .event-of-day").removeClass("lock-btn");
                if (offer.eventID) $("#event .chances").removeClass("lock-btn");
            }
            // Spristupni tiket, tlacitko Submit ticket a Clear ticket - ak uz dobehli vsetky add odds
            main.unlockSbmButtons();
            modal.hideLoading();

        } catch (e) {
            console.error("ERROR catched in function: " + main.catchFunctionCall(arguments));
            // Spristupni tlacitka vsetkych eventov a chanceType
            $("#events fieldset").removeClass("lock-btn");
            $("#eventsOfDay .event-of-day").removeClass("lock-btn");
            if (offer.eventID) $("#event .chances").removeClass("lock-btn");
            // Spristupni tiket
            main.unlockSbmButtons();
            modal.hideLoading();
        }
    },

    // Funkcia na otvorenie timovej analyzi na hornej obrazovke
    openTeamAnalysis(regionID, teamOrder) {
        try {
            if (profile.TeamAnalysisRegions.length) {
                $("#teamAnalysis #teamAnalysisLogos a").removeClass("logo-pressed lock-btn");
                if (regionID && teamOrder) {
                    $("#teamAnalysis #teamAnalysisLogos .region-" + regionID + "-logo-" + teamOrder).parent("a").addClass("logo-pressed lock-btn");
                    communication.topScreen('teamAnalysis', {"regionID": regionID, "teamOrder": teamOrder});
                    return true;
                } else if (!teamOrder) {
                    communication.topScreen('teamAnalysis', {screenShow: false});
                    return false;
                }
            } else {
                return false;
            }
        } catch (e) {
            console.error("ERROR catched in function: " + main.catchFunctionCall(arguments));
            return false;
        }
    },

    // Zobrazenie listu timovych analyz
    showTeamAnalysis(show, regionID) {
        // TODO - tymova analyza sa neotvori automaticky pri otvoreni teamu, vie sa zavriet hromadne - aktualne sa nepouziva
        try {
            if (regionID) {
                var teamAnalysisButton, teamAnalysisList;
                if (offer.teamAnalysisModal) {
                    teamAnalysisButton = $("#teamAnalysis.team-analysis-RE" + regionID);
                    teamAnalysisList = $("#sportsBook #RE" + regionID);
                } else {
                    teamAnalysisButton = $("#sportsBook #RE" + regionID);
                    teamAnalysisList = $("#teamAnalysis.team-analysis-RE" + regionID);
                }
                if (show) {
                    teamAnalysisButton.find(".team-analysis-button")
                        .attr("onclick", "events.showTeamAnalysis(false," + regionID + ")").addClass("team-analysis-opened");
                    teamAnalysisList.find("#teamAnalysisList").show();
                } else {
                    teamAnalysisButton.find(".team-analysis-button")
                        .attr("onclick", "events.showTeamAnalysis(true," + regionID + ")").removeClass("team-analysis-opened");
                    teamAnalysisList.find("#teamAnalysisList").hide();
                    communication.topScreen('teamAnalysis', {screenShow: false});
                }
                return true;
            } else {


                return false;
            }
        } catch (e) {
            console.error("ERROR catched in function: " + main.catchFunctionCall(arguments));
            return false;
        }
    },

    // Naplnenie timovej analyzy logami timov
    logosTeamAnalysis(regionID) {
        try {
            if (regionID) {
                var logosHtml = "", rows = logos = 0, skip = [];
                switch (regionID) {
                    // Podmienka pre NHL
                    case 1016:
                        rows = 4;
                        logos = 8;
                        skip = [24];
                        break;
                    // Podmienka pre NBA
                    case 1027:
                        rows = 6;
                        logos = 5;
                        break;
                }
                for (r = 0; r < rows; r += 1) {
                    logosHtml += '<div class="team-analysis-row-' + (r + 1) + ' region-' + regionID + '-logos">';
                    for (l = 1 + r * logos; l <= logos + r * logos; l += 1) {
                        if (!skip.includes(l)) logosHtml += '<a onclick="events.openTeamAnalysis(' + regionID + ',' + l + ')">' +
                            '<div class="region-' + regionID + '-logo-' + l + '"></div></a>';
                    }
                    logosHtml += '</div>'
                }
                logosHtml += '</div>';

                $("#sportsBook #" + offer.pointer + " #teamAnalysisList #teamAnalysisLogos").html(logosHtml);
                return true;

            } else {
                return false;
            }
        } catch (e) {
            console.error("ERROR catched in function: " + main.catchFunctionCall(arguments));
            return false;
        }
    }
};
